module.exports = __webpack_public_path__ + "static/media/ic_publish.f69381d2.svg";